export const ExtraAttributesGridAction = {
    RowSelect: "eagrid.row.selected",
    SelectRow: "eagrid.row.select",
};
